import {openClass} from "../settings/settings";

let popinOverlay = $('.popin-overlay'),
  popinClose = $('.popin-content .js-close'),
  popinCloseNoPrevent = $('.js-close-no-prevent'),
  popinSubmit = $('.save-popin-link'),
  popinMessage = $('.popin-message'),
  popin = $('.js-popin-wrapper'),
  body = $('body');

export function closePopin() {
  popin.removeClass(openClass);
  popinOverlay.removeClass(openClass);
  body.removeClass('not-scrollable');
}

export function closeDeliveryPopin() {
  document.querySelector(".js-cart-item-popin-wrapper.is-open").classList.remove('is-open');
  document.querySelector('.popin-overlay').classList.remove('is-open');
  document.querySelector('body').classList.remove('not-scrollable');
}

function itemDeliveryPopin() {
  let popinOverlay = document.querySelector('.popin-overlay');
  let body = document.querySelector('body');
  let openLinks = document.getElementsByClassName('js-cart-item-popin-open');
  for (const item of openLinks) {
    item.addEventListener('click', () => {
      document.querySelector(".js-cart-item-popin-wrapper[data-item-id='"+item.dataset.itemId+"']").classList.add('is-open');
      popinOverlay.classList.add('is-open');
      document.querySelector('body').classList.add('not-scrollable');
    });
  }
  let popins = document.querySelectorAll('.js-cart-item-popin-wrapper');
  for (const popin of popins) {
    popin.querySelector('.js-close').addEventListener('click', () => {
      popin.classList.remove('is-open');
      popinOverlay.classList.remove('is-open');
      body.classList.remove('not-scrollable');
    });
  }
  popinOverlay && popinOverlay.addEventListener('click', () => {
    document.querySelector(".js-cart-item-popin-wrapper.is-open").classList.remove('is-open');
    popinOverlay.classList.remove('is-open');
    body.classList.remove('not-scrollable');
  });
  document.body.addEventListener("keydown", function(e) {
    if(e.key === "Escape") {
      document.querySelector(".js-cart-item-popin-wrapper.is-open").removeClass('is-open');
      popinOverlay.removeClass('is-open');
      body.removeClass('not-scrollable');
    }
  });
}

$(document).ready(function() {
  itemDeliveryPopin();
  let popinOpen = $('.js-popin-open');
  popinOpen.on('click', function(e) {
    e.preventDefault();
    // data-attribute from click.
    popin.addClass(openClass);
    popinOverlay.addClass(openClass);
    body.addClass('not-scrollable');
    popinSubmit.attr('href', $(this).attr('href'));
    popin.attr('data-item-id', $(e.target).parent().attr('data-item-id'));
    popinSubmit.html($(this).attr('alt'));
    popinMessage.html($(this).attr('data-text'));

    if (popinOpen.hasClass('item-edit-enable')) {
      popinSubmit.addClass('enable');
    }
  });

  popinOverlay.on('click', function() {
    popin.removeClass(openClass);
    popinOverlay.removeClass(openClass);
    body.removeClass('not-scrollable');
  });

  popinClose.on('click', function(e) {
    e.preventDefault();

    popin.removeClass(openClass);
    popinOverlay.removeClass(openClass);
    body.removeClass('not-scrollable');
  });

  popinCloseNoPrevent.on('click', function() {
    popin.removeClass(openClass);
    popinOverlay.removeClass(openClass);
    body.removeClass('not-scrollable');
  });
});

document.body.addEventListener("keydown", function(e) {
  if(e.key === "Escape") {
    popin.removeClass(openClass);
    popinOverlay.removeClass(openClass);
    body.removeClass('not-scrollable');
  }
});
